/**
 * B2B Netflix Academy — gedeelde stijl & rekenregels (opdrachtgevers-cockpit).
 * Rijkleur: Mentaal = groen, Ergonomie = rood, Cultuur & Teambuilding = WKR-oranje, Vakinhoudelijk = paars.
 */
import { Laptop, Landmark, BookOpen, Building2, Ticket, KeyRound } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { B2bInkoopType, B2bTraining, RfqLocatie, RfqPlanning, RfqStatus } from '../../services/b2bAcademyApi';

export const eur = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });

/** "€ 950,-" voor ronde bedragen, anders "€ 142,50". */
export function prijs(bedrag: number): string {
  return Number.isInteger(bedrag) ? `${eur.format(bedrag).replace(/,00$/, '')},-` : eur.format(bedrag);
}

export const WKR_ORANJE = '#FF9800';
/** Corporate donkerblauw van het tegel-infovlak (.course-card-info-block). */
export const INFO_BLAUW = '#0A192F';

export const LEERVORM: Record<B2bTraining['leervorm'], { label: string; icon: LucideIcon }> = {
  e_learning: { label: 'Online', icon: Laptop },
  workshop: { label: 'Workshop', icon: Landmark },
  opleiding: { label: 'Traject', icon: BookOpen },
};

export const INKOOP: Record<B2bInkoopType, { label: string; icon: LucideIcon; emoji: string }> = {
  incompany: { label: 'Incompany Maatwerk', icon: Building2, emoji: '🏢' },
  bulk_seats: { label: 'Bulk Seats', icon: Ticket, emoji: '🎟️' },
  licentie: { label: 'Licenties', icon: KeyRound, emoji: '🔑' },
};

export const LOCATIE_OPTIES: Array<{ key: RfqLocatie; emoji: string; label: string; uitleg: string }> = [
  { key: 'eigen_locatie', emoji: '🏢', label: 'Fysiek op eigen bedrijfslocatie', uitleg: 'De trainer komt naar uw vestiging' },
  { key: 'extern', emoji: '🏫', label: 'Externe locatie', uitleg: 'Trainingslocatie van de opleider of een gehuurde zaal' },
  { key: 'online', emoji: '💻', label: 'Online Live Classroom', uitleg: 'Interactief via videoverbinding' },
];

export const PLANNING_OPTIES: Array<{ key: RfqPlanning; emoji: string; label: string; kleur: string }> = [
  { key: 'binnen_1_maand', emoji: '🟢', label: 'Binnen 1 maand', kleur: '#22C55E' },
  { key: 'binnen_3_maanden', emoji: '🟨', label: 'Binnen 3 maanden', kleur: '#EAB308' },
  { key: 'overleg', emoji: '⏳', label: 'In onderling overleg', kleur: '#94A3B8' },
];

export const STATUS_INFO: Record<RfqStatus, { label: string; cls: string }> = {
  RFQ_SUBMITTED: { label: 'Aanvraag ingediend', cls: 'border-sky-400/30 bg-sky-400/10 text-sky-700' },
  OFFER_SENT: { label: 'Offerte ontvangen', cls: 'border-amber-400/30 bg-amber-400/10 text-amber-700' },
  OFFER_ACCEPTED: { label: 'Geaccepteerd · Ingeroosterd', cls: 'border-emerald-400/30 bg-emerald-400/10 text-emerald-700' },
  OFFER_DECLINED: { label: 'Afgewezen (archief)', cls: 'border-gray-200 bg-white text-gray-500' },
};

export function datumKort(iso: string): string {
  return new Date(iso).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' });
}
